<form [formGroup]="datosAcudienteForm">
  <div class="data-form-cont">
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="acudiente" required>
        <mat-error *ngIf="datosAcudienteForm.get('acudiente').invalid">{{getErrorMessage('acudiente')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Celular</mat-label>
        <input matInput formControlName="acudienteTelMovil" required>
        <mat-error *ngIf="datosAcudienteForm.get('acudienteTelMovil').invalid">{{getErrorMessage('acudienteTelMovil')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Teléfono fijo</mat-label>
        <input matInput formControlName="acudienteTel" required>
        <mat-error *ngIf="datosAcudienteForm.get('acudienteTel').invalid">{{getErrorMessage('acudienteTel')}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>
